import { RootDispatch } from 'storage/store';

export const detectBrowser = (dispatch: RootDispatch) => {
  const { userAgent } = navigator;
  if (userAgent.match(/iphone/i)) {
    dispatch.pwa.setIsIphone(true);
  } else {
    dispatch.pwa.setIsIphone(false);
  }
};
